import { Key, SelectHTMLAttributes } from "react";
import Text from "./Text";

interface IOption {
  key: Key;
  label: string;
  value: any;
}

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  inputClassName?: string;
  label?: string;
  labelWidth?: number;
  options: IOption[];
}

export default function SelectField(props: Props) {
  const {
    className,
    inputClassName,
    label,
    labelWidth,
    options,
    ...selectProps
  } = props;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {label && (
        <Text text={label} width={labelWidth} size="medium" weight="medium" />
      )}
      <select
        className={`text-md h-full w-full rounded border border-gray-300 p-1 text-gray-700 ${inputClassName}`}
        {...selectProps}
      >
        <option disabled value={"undefined"}>
          Select an option
        </option>
        {options.map((o) => (
          <option key={o.key} label={o.label} value={o.value}></option>
        ))}
      </select>
    </div>
  );
}
